'use client';

import { useEffect, useRef, useState } from 'react';

import cx from 'classnames';

import { ButtonVariant } from '~/ui/components/button';
import { PlayPauseButton } from '~/ui/components/button/playPause';
import { Column, Grid } from '~/ui/components/grid';
import { Breakpoint } from '~/ui/styles/grid';

import styles from './header.module.scss';

export interface HeaderProps {
  title?: string | null;
  heroSrc: string;
}

export function Header({ title, heroSrc }: HeaderProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) {
      return;
    }

    if (paused) {
      video.pause();
    } else {
      video.play();
    }
  }, [paused]);

  return (
    <div className={cx(styles.root, 'module')}>
      <div className={styles.sticky}>
        <div className={styles.gradient} />
        <video
          autoPlay
          muted
          loop
          playsInline
          aria-hidden
          preload="auto"
          src={heroSrc}
          className={styles.video}
          ref={videoRef}
        ></video>
        <PlayPauseButton
          onClick={() => setPaused(prev => !prev)}
          isPaused={paused}
          variant={ButtonVariant.PRIMARY_TRANSPARENT}
          ariaLabels={{ paused: 'Play', playing: 'Pause' }}
          className={styles.pauseButton}
        />
      </div>
      <Grid className={styles.content} fullWidth>
        <Column span={{ [Breakpoint.MOBILE]: 5, [Breakpoint.TABLET]: 5, [Breakpoint.DESKTOP]: 5 }}>
          <h1 className={cx(styles.section, 'pageTitleSmallTypography')}>{title}</h1>
          <p className={cx(styles.section, 'modulesTitleTypography')}>
            Public radio and television have become a treasure trove of culture—and an ongoing
            record of the American story. But decades worth of content is now at risk.
          </p>
          <p className={cx(styles.section, 'modulesTitleTypography')}>
            Today, longtime public television affiliate GBH and the Library of Congress are working
            together to safeguard an astounding collection of public programming for future
            generations.
          </p>
        </Column>
      </Grid>
    </div>
  );
}
